import Vue from 'vue';
import Router from 'vue-router';
import HomePage from '../page/Home.page';

// 开讲
import EntryPages from './entry';
// 课程
import CoursePages from './course';
// 课堂
import ClassPages from './class';
// 其他
import OtherPages from './other';
// 奖学金
import Scholarships from './scholarships';
// 专家义诊
import FreeClinic from './freeClinic';
// 专家答
import Dayima from './dayima';
// 孕育周知
import Knowing from './knowing';
// 小灯塔
import Lighthouse from './lighthouse';

// const UserLive = import('../page/User.page');
const UserLive = () => import('../page/User.page');
const UserCourse = () => import('../page/UserCourse.page');
const MyCourse = () => import('../page/user/MyCourse.page');
const MyTinyCourse = () => import('../page/MyTinyCourse.page');
const MyVideo = () => import('../page/MyVideo.page');
const UserBinding = () => import('../page/UserBinding.page');
const MyIncome = () => import('../page/MyIncome/Index.page');
const testPage = () => import('../page/test/test.page');

const WebviewDebug = () => import('../page/webviewDebug/index.page');

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: '/live',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    ...EntryPages,
    ...CoursePages,
    ...ClassPages,
    ...OtherPages,
    ...Scholarships,
    ...FreeClinic,
    ...Dayima,
    ...Knowing,
    ...Lighthouse,
    {
      path: '/user',    // 个人中心
      name: 'UserLive',
      component: UserLive,
      meta: {
        pageTitle: '个人信息',
        requiresAuth: true,
        authType: 'user'
      },
      children: [
        {
          // 当 /user/:id/profile 匹配成功，
          // UserProfile 会被渲染在 User 的 <router-view> 中
          path: 'profile',
          component: HomePage
        },
        {
          // 当 /user/:id/posts 匹配成功
          // UserPosts 会被渲染在 User 的 <router-view> 中
          path: 'live',
          component: HomePage
        }
      ]
    },

    // 我的开讲
    {
      path: '/user/courseList/',
      name: 'UserCourse',
      component: UserCourse,
      meta: {
        pageTitle: '我的开讲',
        requiresAuth: true,
        authType: 'user'
      }
    },

    // 我的课程
    {
      path: '/user/myCourse/',
      name: 'MyCourse',
      component: MyCourse,
      meta: {
        pageTitle: '我的课程',
        requiresAuth: true,
        authType: 'user'
      }
    },

    // 我的音频
    {
      path: '/user/myTinyCourse',
      name: 'MyTinyCourse',
      component: MyTinyCourse,
      meta: {
        pageTitle: '我的音频',
        requiresAuth: true,
        authType: 'user'
      }
    },

    // 我的视频
    {
      path: '/user/myVideo',
      name: 'MyVideo',
      component: MyVideo,
      meta: {
        pageTitle: '我的视频',
        requiresAuth: true,
        authType: 'user'
      }
    },

    // 我的
    {
      path: '/user/myIncome',
      name: 'myIncome',
      component: MyIncome,
      meta: {
        pageTitle: '分享收益',
        requiresAuth: true,
        authType: 'user'
      }
    },
    {
      path: '/test',
      name: 'testPage',
      component: testPage,
      meta: {
        pageTitle: 'test'
      }
    },


    // 绑定手机
    {
      path: '/user/binding/',
      name: 'UserBinding',
      component: UserBinding,
      meta: {
        pageTitle: '完善资料',
        requiresAuth: true,
        authType: 'user'
      }
    },

    // webview debug
    {
      path: '/webviewDebug',
      name: 'webviewDebug',
      component: WebviewDebug,
      meta: {
        pageTitle: 'Webview Actions',
        requiresAuth: false
      }
    },


    { path: '*', component: () => import('@/comm/NotFound.page') }
  ]
});



// WEBPACK FOOTER //
// ./src/user/router/index.js